module.exports = __webpack_public_path__ + "img/icon_calendar_black.94fbc9b7.svg";